import { render } from "./ClustersView.vue?vue&type=template&id=6eed8424&scoped=true&ts=true"
import script from "./ClustersView.vue?vue&type=script&lang=ts"
export * from "./ClustersView.vue?vue&type=script&lang=ts"

import "./ClustersView.vue?vue&type=style&index=0&id=6eed8424&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eed8424"]])

export default __exports__